import React, { Fragment } from 'react';

import { cn } from '@/utils/styles.utils';

export const PRODUCT_NONE_AMOUNT = 0;
export const PRODUCT_SMALL_AMOUNT = 1;
export const PRODUCT_MEDIUM_AMOUNT = 5;
export const PRODUCT_BIG_AMOUNT = 9;
export const getProductAvailability = (amount: number) => {
  if (amount >= PRODUCT_BIG_AMOUNT) {
    return 'big';
  }
  if (amount >= PRODUCT_MEDIUM_AMOUNT) {
    return 'medium';
  }
  if (amount >= PRODUCT_SMALL_AMOUNT) {
    return 'small';
  }
  return 'none';
};

interface Props {
  quantity: number;
}

export const ProductQuantity = (props: Props) => {
  const { quantity } = props;
  const availability = getProductAvailability(quantity);
  return (
    <>
      <div
        className={cn(
          'relative h-1.5 w-16 overflow-hidden rounded-full bg-grey-300',
          'rounded-full after:absolute after:left-0 after:h-1.5 after:content-[""]',
          {
            'after:w-[20%] after:bg-red-500': availability === 'small',
            'after:w-[50%] after:bg-orange-500': availability === 'medium',
            'after:w-[90%] after:bg-green-500': availability === 'big',
          },
        )}
      />
    </>
  );
};
